import React from 'react';
import { Button } from '@beef/legacy-ui-kit';

const BigButton = ({ className, ...otherProps }) => (
  <Button className={['big', className]} {...otherProps} />
);

export default BigButton;
